import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { TipoLancamentoConfiguracao } from '../../../models/tipo-lancamento-configuracao';
import { ConfiguracaoCaixaApiService } from '../../../services/configuracao-caixa-api.service';
import { MessageService } from '@services/message.service';

@Component({
  selector: 'app-mesclar-tipos-em-massa-dialog',
  standalone: false,
  templateUrl: './mesclar-tipos-em-massa-dialog.component.html',
  styleUrl: './mesclar-tipos-em-massa-dialog.component.scss'
})
export class MesclarTiposEmMassaDialogComponent {

  title: string = 'Mesclar tipos selecionados';
  tipos: TipoLancamentoConfiguracao[] = [];
  nomeFinal: string = '';

  constructor(
    private configuracaoCaixaApiService: ConfiguracaoCaixaApiService,
    private messageService: MessageService,
    private dialogRef: MatDialogRef<MesclarTiposEmMassaDialogComponent>
  ) { }

  public salvarClick(): void {
    if (!this.nomeFinal?.trim()) {
      this.messageService.showToastWarning('O nome do tipo não pode ser vazio');
      return;
    }

    this.configuracaoCaixaApiService.mesclarTiposEmMassa({
      tiposIds: this.tipos.map(t => t.id),
      nomeFinal: this.nomeFinal
    }).subscribe(() => {
      this.messageService.showToastSuccess('Salvo com sucesso');
      this.dialogRef.close(true);
    });
  }
}
